import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableAffaireDetailsPage = withAsyncLoading(async () =>
    import('./AffaireDetailsPage').then((res) => res.AffaireDetailsPage)
);

export { LoadableAffaireDetailsPage };
